<template>
    <div>
        <van-cell :title="showText" @click="setHidden(false)" is-link />
        <van-popup v-model="isShow" position="bottom">
            <van-datetime-picker
                v-model="dateValue"
                v-bind="options"
                @cancel="setHidden(true)"
                @confirm="onConfirm"
            />
        </van-popup>
    </div>
</template>
<script>
import moment from "moment";
export default {
    model: {
        prop: "value",
        event: "updateValue"
    },
    props: {
        options: null,
        showFormat: {
            default: "YYYY-MM-DD"
        },
        value: {
            type: Date
        }
    },
    data() {
        return {
            dateValue: null,
            showText: "",
            isShow: false
        };
    },
    watch: {
        value: {
            handler(v) {
                if (v) {
                    this.showText = moment(v).format(this.showFormat);
                    this.dateValue = v;
                }
            },
            immediate: true
        }
    },
    methods: {
        setHidden(v) {
            this.isShow = !v;
        },
        onConfirm(v) {
            this.setHidden(true);
            // 双向绑定数据处理
            this.$emit("updateValue", v);
        }
    }
};
</script>
<style lang="scss" scoped>
</style>
